import { combineReducers } from 'redux';
import { rScoreReducer } from '../views/rscore/redux/reducer';
const reducers = combineReducers({
  RscoreDatas: rScoreReducer,
});
export default reducers;
